@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-690_594_754)
internal val Res.drawable.crimson_door: DrawableResource by lazy {
      DrawableResource("drawable:crimson_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_994_990)
internal val Res.drawable.crimson_fence: DrawableResource by lazy {
      DrawableResource("drawable:crimson_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_146_497_324)
internal val Res.drawable.crimson_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:crimson_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-934_230_220)
internal val Res.drawable.crimson_fungus: DrawableResource by lazy {
      DrawableResource("drawable:crimson_fungus", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_fungus.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_652_877_774)
internal val Res.drawable.crimson_hyphae: DrawableResource by lazy {
      DrawableResource("drawable:crimson_hyphae", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_hyphae.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(505_614_927)
internal val Res.drawable.crimson_nylium: DrawableResource by lazy {
      DrawableResource("drawable:crimson_nylium", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_nylium.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_582_307_610)
internal val Res.drawable.crimson_planks: DrawableResource by lazy {
      DrawableResource("drawable:crimson_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(600_537_625)
internal val Res.drawable.crimson_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:crimson_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(505_938_517)
internal val Res.drawable.crimson_roots: DrawableResource by lazy {
      DrawableResource("drawable:crimson_roots", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_roots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_825_057_943)
internal val Res.drawable.crimson_sign: DrawableResource by lazy {
      DrawableResource("drawable:crimson_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_441_720_294)
internal val Res.drawable.crimson_slab: DrawableResource by lazy {
      DrawableResource("drawable:crimson_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_916_832_176)
internal val Res.drawable.crimson_stairs: DrawableResource by lazy {
      DrawableResource("drawable:crimson_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_005_339_841)
internal val Res.drawable.crimson_stem: DrawableResource by lazy {
      DrawableResource("drawable:crimson_stem", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_stem.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(320_320_776)
internal val Res.drawable.crimson_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:crimson_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/crimson_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_027_935_422)
internal val Res.drawable.crossbow: DrawableResource by lazy {
      DrawableResource("drawable:crossbow", setOf(
        ResourceItem(setOf(), "${MD}drawable/crossbow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_940_987_512)
internal val Res.drawable.crying_obsidian: DrawableResource by lazy {
      DrawableResource("drawable:crying_obsidian", setOf(
        ResourceItem(setOf(), "${MD}drawable/crying_obsidian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(900_823_495)
internal val Res.drawable.cut_red_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:cut_red_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/cut_red_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(308_406_542)
internal val Res.drawable.cut_red_sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:cut_red_sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/cut_red_sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-213_626_520)
internal val Res.drawable.cut_sandstone: DrawableResource by lazy {
      DrawableResource("drawable:cut_sandstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/cut_sandstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_607_356)
internal val Res.drawable.cut_sandstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:cut_sandstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/cut_sandstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_220_571_668)
internal val Res.drawable.cyan_banner: DrawableResource by lazy {
      DrawableResource("drawable:cyan_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(156_725_850)
internal val Res.drawable.cyan_bed: DrawableResource by lazy {
      DrawableResource("drawable:cyan_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-748_916_889)
internal val Res.drawable.cyan_carpet: DrawableResource by lazy {
      DrawableResource("drawable:cyan_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_089_566_920)
internal val Res.drawable.cyan_concrete: DrawableResource by lazy {
      DrawableResource("drawable:cyan_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_312_460_604)
internal val Res.drawable.cyan_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:cyan_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_695_016_846)
internal val Res.drawable.cyan_dye: DrawableResource by lazy {
      DrawableResource("drawable:cyan_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(814_079_312)
internal val Res.drawable.cyan_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:cyan_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-139_040_581)
internal val Res.drawable.cyan_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:cyan_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_140_249_205)
internal val Res.drawable.cyan_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:cyan_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_526_201_808)
internal val Res.drawable.cyan_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:cyan_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(937_838_058)
internal val Res.drawable.cyan_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:cyan_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_096_273_477)
internal val Res.drawable.cyan_wool: DrawableResource by lazy {
      DrawableResource("drawable:cyan_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyan_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_248_320_789)
internal val Res.drawable.damaged_anvil: DrawableResource by lazy {
      DrawableResource("drawable:damaged_anvil", setOf(
        ResourceItem(setOf(), "${MD}drawable/damaged_anvil.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_466_125_347)
internal val Res.drawable.dandelion: DrawableResource by lazy {
      DrawableResource("drawable:dandelion", setOf(
        ResourceItem(setOf(), "${MD}drawable/dandelion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_587_966_332)
internal val Res.drawable.dark_oak_boat: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(617_165_666)
internal val Res.drawable.dark_oak_button: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(833_633_581)
internal val Res.drawable.dark_oak_door: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_752_307_177)
internal val Res.drawable.dark_oak_fence: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_484_908_857)
internal val Res.drawable.dark_oak_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-19_659_667)
internal val Res.drawable.dark_oak_leaves: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-442_240_770)
internal val Res.drawable.dark_oak_log: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-317_113_124)
internal val Res.drawable.dark_oak_planks: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-290_861_178)
internal val Res.drawable.dark_oak_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-526_217_858)
internal val Res.drawable.dark_oak_sapling: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(537_911_308)
internal val Res.drawable.dark_oak_sign: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(362_998_648)
internal val Res.drawable.dark_oak_slab: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_215_112_618)
internal val Res.drawable.dark_oak_stairs: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-812_074_167)
internal val Res.drawable.dark_oak_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_946_059_618)
internal val Res.drawable.dark_oak_wood: DrawableResource by lazy {
      DrawableResource("drawable:dark_oak_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_oak_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_023_497_936)
internal val Res.drawable.dark_prismarine: DrawableResource by lazy {
      DrawableResource("drawable:dark_prismarine", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_prismarine.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_639_218_247)
internal val Res.drawable.dark_prismarine_slab: DrawableResource by lazy {
      DrawableResource("drawable:dark_prismarine_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_prismarine_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_315_851_880)
internal val Res.drawable.dark_prismarine_stairs: DrawableResource by lazy {
      DrawableResource("drawable:dark_prismarine_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/dark_prismarine_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-426_849_988)
internal val Res.drawable.daylight_detector: DrawableResource by lazy {
      DrawableResource("drawable:daylight_detector", setOf(
        ResourceItem(setOf(), "${MD}drawable/daylight_detector.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_205_357_601)
internal val Res.drawable.dead_brain_coral: DrawableResource by lazy {
      DrawableResource("drawable:dead_brain_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_brain_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_234_287)
internal val Res.drawable.dead_brain_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:dead_brain_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_brain_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_045_663_422)
internal val Res.drawable.dead_brain_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:dead_brain_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_brain_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-593_344_607)
internal val Res.drawable.dead_bubble_coral: DrawableResource by lazy {
      DrawableResource("drawable:dead_bubble_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_bubble_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_075_244_757)
internal val Res.drawable.dead_bubble_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:dead_bubble_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_bubble_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(949_427_801)
internal val Res.drawable.dead_bubble_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:dead_bubble_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_bubble_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-935_380_230)
internal val Res.drawable.dead_bush: DrawableResource by lazy {
      DrawableResource("drawable:dead_bush", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_bush.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(643_058_968)
internal val Res.drawable.dead_fire_coral: DrawableResource by lazy {
      DrawableResource("drawable:dead_fire_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_fire_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_648_941_670)
internal val Res.drawable.dead_fire_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:dead_fire_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_fire_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-302_156_852)
internal val Res.drawable.dead_fire_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:dead_fire_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_fire_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(549_132_802)
internal val Res.drawable.dead_horn_coral: DrawableResource by lazy {
      DrawableResource("drawable:dead_horn_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_horn_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_167_484_804)
internal val Res.drawable.dead_horn_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:dead_horn_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_horn_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(556_443_581)
internal val Res.drawable.dead_horn_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:dead_horn_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_horn_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(86_232_584)
internal val Res.drawable.dead_tube_coral: DrawableResource by lazy {
      DrawableResource("drawable:dead_tube_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_tube_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_125_072_343)
internal val Res.drawable.dead_tube_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:dead_tube_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_tube_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(806_395_019)
internal val Res.drawable.dead_tube_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:dead_tube_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/dead_tube_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-486_387_267)
internal val Res.drawable.debug_stick: DrawableResource by lazy {
      DrawableResource("drawable:debug_stick", setOf(
        ResourceItem(setOf(), "${MD}drawable/debug_stick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(890_100_687)
internal val Res.drawable.detector_rail: DrawableResource by lazy {
      DrawableResource("drawable:detector_rail", setOf(
        ResourceItem(setOf(), "${MD}drawable/detector_rail.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-944_421_486)
internal val Res.drawable.diamond: DrawableResource by lazy {
      DrawableResource("drawable:diamond", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_678_648_640)
internal val Res.drawable.diamond_axe: DrawableResource by lazy {
      DrawableResource("drawable:diamond_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(770_912_064)
internal val Res.drawable.diamond_block: DrawableResource by lazy {
      DrawableResource("drawable:diamond_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_869_357_258)
internal val Res.drawable.diamond_boots: DrawableResource by lazy {
      DrawableResource("drawable:diamond_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(38_491_281)
internal val Res.drawable.diamond_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:diamond_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_930_582)
internal val Res.drawable.diamond_helmet: DrawableResource by lazy {
      DrawableResource("drawable:diamond_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(439_616_854)
internal val Res.drawable.diamond_hoe: DrawableResource by lazy {
      DrawableResource("drawable:diamond_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-979_037_833)
internal val Res.drawable.diamond_horse_armor: DrawableResource by lazy {
      DrawableResource("drawable:diamond_horse_armor", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_horse_armor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_051_582_200)
internal val Res.drawable.diamond_leggings: DrawableResource by lazy {
      DrawableResource("drawable:diamond_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_070_913_301)
internal val Res.drawable.diamond_ore: DrawableResource by lazy {
      DrawableResource("drawable:diamond_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_671_394_281)
internal val Res.drawable.diamond_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:diamond_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_088_055_568)
internal val Res.drawable.diamond_shovel: DrawableResource by lazy {
      DrawableResource("drawable:diamond_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-107_472_447)
internal val Res.drawable.diamond_sword: DrawableResource by lazy {
      DrawableResource("drawable:diamond_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/diamond_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(354_844_939)
internal val Res.drawable.diorite: DrawableResource by lazy {
      DrawableResource("drawable:diorite", setOf(
        ResourceItem(setOf(), "${MD}drawable/diorite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(749_174_567)
internal val Res.drawable.diorite_slab: DrawableResource by lazy {
      DrawableResource("drawable:diorite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/diorite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_413_817_036)
internal val Res.drawable.diorite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:diorite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/diorite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_360_655_245)
internal val Res.drawable.diorite_wall: DrawableResource by lazy {
      DrawableResource("drawable:diorite_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/diorite_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-176_566_552)
internal val Res.drawable.dirt: DrawableResource by lazy {
      DrawableResource("drawable:dirt", setOf(
        ResourceItem(setOf(), "${MD}drawable/dirt.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-164_037_892)
internal val Res.drawable.dispenser: DrawableResource by lazy {
      DrawableResource("drawable:dispenser", setOf(
        ResourceItem(setOf(), "${MD}drawable/dispenser.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_234_456_644)
internal val Res.drawable.dolphin_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:dolphin_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/dolphin_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_170_230_956)
internal val Res.drawable.donkey_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:donkey_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/donkey_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-634_280_657)
internal val Res.drawable.dragon_breath: DrawableResource by lazy {
      DrawableResource("drawable:dragon_breath", setOf(
        ResourceItem(setOf(), "${MD}drawable/dragon_breath.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-227_068_147)
internal val Res.drawable.dragon_egg: DrawableResource by lazy {
      DrawableResource("drawable:dragon_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/dragon_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_276_191_497)
internal val Res.drawable.dragon_head: DrawableResource by lazy {
      DrawableResource("drawable:dragon_head", setOf(
        ResourceItem(setOf(), "${MD}drawable/dragon_head.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_638_237_489)
internal val Res.drawable.dried_kelp: DrawableResource by lazy {
      DrawableResource("drawable:dried_kelp", setOf(
        ResourceItem(setOf(), "${MD}drawable/dried_kelp.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_916_662_395)
internal val Res.drawable.dried_kelp_block: DrawableResource by lazy {
      DrawableResource("drawable:dried_kelp_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/dried_kelp_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_070_549_848)
internal val Res.drawable.dropper: DrawableResource by lazy {
      DrawableResource("drawable:dropper", setOf(
        ResourceItem(setOf(), "${MD}drawable/dropper.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_919_757_074)
internal val Res.drawable.drowned_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:drowned_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/drowned_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_278_949_905)
internal val Res.drawable.egg: DrawableResource by lazy {
      DrawableResource("drawable:egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/egg.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable2Resources(map: MutableMap<String, DrawableResource>) {
  map.put("crimson_door", Res.drawable.crimson_door)
  map.put("crimson_fence", Res.drawable.crimson_fence)
  map.put("crimson_fence_gate", Res.drawable.crimson_fence_gate)
  map.put("crimson_fungus", Res.drawable.crimson_fungus)
  map.put("crimson_hyphae", Res.drawable.crimson_hyphae)
  map.put("crimson_nylium", Res.drawable.crimson_nylium)
  map.put("crimson_planks", Res.drawable.crimson_planks)
  map.put("crimson_pressure_plate", Res.drawable.crimson_pressure_plate)
  map.put("crimson_roots", Res.drawable.crimson_roots)
  map.put("crimson_sign", Res.drawable.crimson_sign)
  map.put("crimson_slab", Res.drawable.crimson_slab)
  map.put("crimson_stairs", Res.drawable.crimson_stairs)
  map.put("crimson_stem", Res.drawable.crimson_stem)
  map.put("crimson_trapdoor", Res.drawable.crimson_trapdoor)
  map.put("crossbow", Res.drawable.crossbow)
  map.put("crying_obsidian", Res.drawable.crying_obsidian)
  map.put("cut_red_sandstone", Res.drawable.cut_red_sandstone)
  map.put("cut_red_sandstone_slab", Res.drawable.cut_red_sandstone_slab)
  map.put("cut_sandstone", Res.drawable.cut_sandstone)
  map.put("cut_sandstone_slab", Res.drawable.cut_sandstone_slab)
  map.put("cyan_banner", Res.drawable.cyan_banner)
  map.put("cyan_bed", Res.drawable.cyan_bed)
  map.put("cyan_carpet", Res.drawable.cyan_carpet)
  map.put("cyan_concrete", Res.drawable.cyan_concrete)
  map.put("cyan_concrete_powder", Res.drawable.cyan_concrete_powder)
  map.put("cyan_dye", Res.drawable.cyan_dye)
  map.put("cyan_glazed_terracotta", Res.drawable.cyan_glazed_terracotta)
  map.put("cyan_shulker_box", Res.drawable.cyan_shulker_box)
  map.put("cyan_stained_glass", Res.drawable.cyan_stained_glass)
  map.put("cyan_stained_glass_pane", Res.drawable.cyan_stained_glass_pane)
  map.put("cyan_terracotta", Res.drawable.cyan_terracotta)
  map.put("cyan_wool", Res.drawable.cyan_wool)
  map.put("damaged_anvil", Res.drawable.damaged_anvil)
  map.put("dandelion", Res.drawable.dandelion)
  map.put("dark_oak_boat", Res.drawable.dark_oak_boat)
  map.put("dark_oak_button", Res.drawable.dark_oak_button)
  map.put("dark_oak_door", Res.drawable.dark_oak_door)
  map.put("dark_oak_fence", Res.drawable.dark_oak_fence)
  map.put("dark_oak_fence_gate", Res.drawable.dark_oak_fence_gate)
  map.put("dark_oak_leaves", Res.drawable.dark_oak_leaves)
  map.put("dark_oak_log", Res.drawable.dark_oak_log)
  map.put("dark_oak_planks", Res.drawable.dark_oak_planks)
  map.put("dark_oak_pressure_plate", Res.drawable.dark_oak_pressure_plate)
  map.put("dark_oak_sapling", Res.drawable.dark_oak_sapling)
  map.put("dark_oak_sign", Res.drawable.dark_oak_sign)
  map.put("dark_oak_slab", Res.drawable.dark_oak_slab)
  map.put("dark_oak_stairs", Res.drawable.dark_oak_stairs)
  map.put("dark_oak_trapdoor", Res.drawable.dark_oak_trapdoor)
  map.put("dark_oak_wood", Res.drawable.dark_oak_wood)
  map.put("dark_prismarine", Res.drawable.dark_prismarine)
  map.put("dark_prismarine_slab", Res.drawable.dark_prismarine_slab)
  map.put("dark_prismarine_stairs", Res.drawable.dark_prismarine_stairs)
  map.put("daylight_detector", Res.drawable.daylight_detector)
  map.put("dead_brain_coral", Res.drawable.dead_brain_coral)
  map.put("dead_brain_coral_block", Res.drawable.dead_brain_coral_block)
  map.put("dead_brain_coral_fan", Res.drawable.dead_brain_coral_fan)
  map.put("dead_bubble_coral", Res.drawable.dead_bubble_coral)
  map.put("dead_bubble_coral_block", Res.drawable.dead_bubble_coral_block)
  map.put("dead_bubble_coral_fan", Res.drawable.dead_bubble_coral_fan)
  map.put("dead_bush", Res.drawable.dead_bush)
  map.put("dead_fire_coral", Res.drawable.dead_fire_coral)
  map.put("dead_fire_coral_block", Res.drawable.dead_fire_coral_block)
  map.put("dead_fire_coral_fan", Res.drawable.dead_fire_coral_fan)
  map.put("dead_horn_coral", Res.drawable.dead_horn_coral)
  map.put("dead_horn_coral_block", Res.drawable.dead_horn_coral_block)
  map.put("dead_horn_coral_fan", Res.drawable.dead_horn_coral_fan)
  map.put("dead_tube_coral", Res.drawable.dead_tube_coral)
  map.put("dead_tube_coral_block", Res.drawable.dead_tube_coral_block)
  map.put("dead_tube_coral_fan", Res.drawable.dead_tube_coral_fan)
  map.put("debug_stick", Res.drawable.debug_stick)
  map.put("detector_rail", Res.drawable.detector_rail)
  map.put("diamond", Res.drawable.diamond)
  map.put("diamond_axe", Res.drawable.diamond_axe)
  map.put("diamond_block", Res.drawable.diamond_block)
  map.put("diamond_boots", Res.drawable.diamond_boots)
  map.put("diamond_chestplate", Res.drawable.diamond_chestplate)
  map.put("diamond_helmet", Res.drawable.diamond_helmet)
  map.put("diamond_hoe", Res.drawable.diamond_hoe)
  map.put("diamond_horse_armor", Res.drawable.diamond_horse_armor)
  map.put("diamond_leggings", Res.drawable.diamond_leggings)
  map.put("diamond_ore", Res.drawable.diamond_ore)
  map.put("diamond_pickaxe", Res.drawable.diamond_pickaxe)
  map.put("diamond_shovel", Res.drawable.diamond_shovel)
  map.put("diamond_sword", Res.drawable.diamond_sword)
  map.put("diorite", Res.drawable.diorite)
  map.put("diorite_slab", Res.drawable.diorite_slab)
  map.put("diorite_stairs", Res.drawable.diorite_stairs)
  map.put("diorite_wall", Res.drawable.diorite_wall)
  map.put("dirt", Res.drawable.dirt)
  map.put("dispenser", Res.drawable.dispenser)
  map.put("dolphin_spawn_egg", Res.drawable.dolphin_spawn_egg)
  map.put("donkey_spawn_egg", Res.drawable.donkey_spawn_egg)
  map.put("dragon_breath", Res.drawable.dragon_breath)
  map.put("dragon_egg", Res.drawable.dragon_egg)
  map.put("dragon_head", Res.drawable.dragon_head)
  map.put("dried_kelp", Res.drawable.dried_kelp)
  map.put("dried_kelp_block", Res.drawable.dried_kelp_block)
  map.put("dropper", Res.drawable.dropper)
  map.put("drowned_spawn_egg", Res.drawable.drowned_spawn_egg)
  map.put("egg", Res.drawable.egg)
}
